import { Box, Flex, FormLabel, Heading } from "@chakra-ui/react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import MainInput from "../../../../components/Form/input";
import MainModel from "../../../../components/Models/main-model";
import { closeAddSectionkModel } from "../../../../modules/admin-modules/models/Actions";
import { getAllCoursesRequest } from "../../../../modules/superadmin-modules/courses/Actions";
import {
  createSuperadminSectionRequest,
  editSuperadminSectionRequest,
} from "../../../../modules/superadmin-modules/sections/Actions";

const AddSection = ({ isAdd, data, setSelectedData }) => {
  const openChapter = useSelector((state) => state.model.isOpen29);
  const isLoading = useSelector((state) => state.adminSections.isLoading);
  const courses = useSelector((state) => state.courses.courses);

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };
  const dispatch = useDispatch();

  const coursesOptions = courses?.map((data) => {
    return { value: data.id, label: data.name };
  });
  const defaultCourse = {
    label: data?.course?.name,
    value: data?.course?.id,
  };
  useEffect(() => {
    dispatch(getAllCoursesRequest());
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    defaultValues: !isAdd ? data : {},
    shouldUnregister: true,
  });

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        {isAdd ? " إضافة قسم" : "تعديل  قسم"}
      </Heading>
    </Box>
  );
  const onSubmit = async (values) => {
    const action = () => {
      dispatch(closeAddSectionkModel());
      setSelectedData({});
      reset();
    };
    if (isAdd) {
      let formData = await new FormData();
      formData.append("name", values?.name);
      formData.append("course_id", values?.course_id);

      console.log(values);

      await dispatch(createSuperadminSectionRequest(formData, action));
    } else {
      let formData = await new FormData();
      formData.append("_method", "PUT");
      const totel = { ...data, ...values };
      formData.append("name", totel?.name);
      formData.append("course_id", totel?.course_id);

      dispatch(
        editSuperadminSectionRequest({
          id: data?.id,
          formData: formData,
          action: action,
        })
      );
    }
  };
  const closeFunc = () => {
    dispatch(closeAddSectionkModel());
    setSelectedData({});
    reset();
  };
  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openChapter}
      buttonTitle={" حفظ التغيرات"}
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex
          dir="rtl"
          w="100%"
          flexWrap="wrap"
          justifyContent="space-between"
          gap="4"
        >
          <Box w="45%">
            <MainInput
              label="اسم القسم "
              defaultValues={data?.name}
              error={errors?.name?.message}
              placeholder="ادخل اسم القسم "
              register={register}
              name="name"
            />
          </Box>
          <Box w="45%">
            <FormLabel>السنة الدراسية : </FormLabel>
            <Select
              options={coursesOptions}
              onChange={(data) => setValue("course_id", data.value)}
              styles={colourStyles}
              placeholder="السنة الدراسية"
              defaultValue={defaultCourse}
            />
          </Box>
        </Flex>
      </form>
    </MainModel>
  );
};

export default AddSection;
